import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import Echo from 'laravel-echo';
import * as Pusher from 'pusher-js';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private echo: Echo<any> | null = null;
  private token: string = '';
  private httpOptions: { headers: HttpHeaders } = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ''
    })
  };

  constructor(
    private secureStorage: SecureStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (!isPlatformBrowser(this.platformId)) return;

    this.token = this.secureStorage.getItem<string>('token') || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`
      })
    };

    this.echo = new Echo({
      broadcaster: 'pusher',
      key: '6e2780442f4587310117',
      cluster: 'eu',
      forceTLS: true,
      wsHost: 'ws-eu.pusher.com',
      wsPort: 443,
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      authEndpoint: `${environment.apiUrl}/broadcasting/auth`,
      client: new Pusher.default('6e2780442f4587310117', {
        cluster: 'eu'
      }),
      auth: {
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    });
  }

  connect(channel: string): Observable<any> {
    return new Observable(observer => {
      try {
        const subscription = this.echo.private(channel)
          .listen('.notification', (data: any) => {
            observer.next(data);
          });

        return () => {
          subscription.stopListening('.notification');
          this.echo.leave(channel);
        };
      } catch (error) {
        observer.error(error);
        console.error('Erreur lors de la connexion au canal WebSocket:', error);
        return () => {};
      }
    });
  }
}
